import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import classes from "./export_extra_info_modal.module.css";
import util from "../../../styles/utilities.module.css";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { releaseGradeOptions, studentCanSeeOptions } from "../../../constants";
import Select from "react-select";

const ExportExtraInfoModal = ({ isOpen,
    backHandler,
    continueHandler,
    exportType,
    setGoogleFormExtraInfo,
    googleFormExtraInfo,
    stepSkipHandler
}) => {


    const [errMsg, setErrMsg] = useState('');
    const {
        point_value_mc_questions,
        point_value_ff_questions,
        release_grade,
        students_can_see: {
            missed_question,
            correct_answer,
            point_values,
        },
    } = googleFormExtraInfo || {}

    const googleFormPreferencesHandler = (type, value) => {
        setGoogleFormExtraInfo((preState) => {
            return ({
                ...preState,
                [type]: value
            });
        })
    }

    const multiSelectChangeHandler = (selectedValues) => {
        const mappedValues = selectedValues.map(({ value }) => value);
        const updatedStudentCanSee = {
            missed_question: mappedValues.includes('Missed question'),
            correct_answer: mappedValues.includes('Correct answers'),
            point_values: mappedValues.includes('Point values'),
        }
        googleFormPreferencesHandler('students_can_see', updatedStudentCanSee)
    }

    const multiSelectValue = () => {
        let value = [];
        missed_question && value.push(studentCanSeeOptions[0])
        correct_answer && value.push(studentCanSeeOptions[1])
        point_values && value.push(studentCanSeeOptions[2])
        return value
    }

    const continueClickHandler = () => {
        if (!errMsg) {
            continueHandler()
        }
    }

    useEffect(() => {
        if (!release_grade || !missed_question || !correct_answer || !point_values) {
            setErrMsg('Something is missing');
        } else {
            setErrMsg('')
        }
    }, [release_grade, missed_question, correct_answer, point_values])

    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={`${classes["modal-overlay"]} ${util.modalOverlay}`}>
            <div className={`${classes.modal} ${util.surface}`}>
                <p className={classes.text}>
                    {`Enter ${exportType} preferences for grading`}
                </p>

                {/* inputs */}
                <div className={classes.googleFormPointFlex}>
                    <div className={classes.googlePointflex1}>
                        <p className={classes.googleformPoints}>Point value for each multiple choice question: </p>
                        <Tooltip title={"point value that will be assigned to each multiple choice question."}>
                            <InfoOutlinedIcon style={{ fontSize: 17 }} />
                        </Tooltip>
                    </div>
                    <input
                        className={classes.googleFormInput}
                        type="number"
                        placeholder="1"
                        value={point_value_mc_questions}
                        onChange={({ target }) => googleFormPreferencesHandler('point_value_mc_questions', target.value)}
                    />
                </div>
                <div className={classes.googleFormPointFlex}>
                    <div className={classes.googlePointflex1}>
                        <p className={classes.googleformPoints}>Point value for each open-ended question: </p>
                        <Tooltip title={"point value that will be assigned to each open-ended question."}>
                            <InfoOutlinedIcon style={{ fontSize: 17 }} />
                        </Tooltip>
                    </div>
                    <input
                        className={classes.googleFormInput}
                        type="number"
                        placeholder="5"
                        value={point_value_ff_questions}
                        onChange={({ target }) => googleFormPreferencesHandler('point_value_ff_questions', target.value)}
                    />
                </div>

                {/* selectors */}
                <div className={classes.googleFormPointFlex}>
                    <p className={classes.googleFormReleaseGrade}>Release grade: </p>
                    <Select
                        value={release_grade ? { label: release_grade, value: release_grade } : ''}
                        onChange={({ value }) => {
                            googleFormPreferencesHandler('release_grade', value)
                        }}
                        options={releaseGradeOptions}
                        className={classes.releaseGrade}
                        placeholder="-Select-"
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                background: "#efefef"
                            }),
                        }}
                    />
                </div>
                <div className={classes.googleFormPointFlex}>
                    <p className={classes.googleFormReleaseGrade}>Student can see: </p>
                    <Select
                        isMulti
                        classNamePrefix="select"
                        onChange={(selectedValues) => multiSelectChangeHandler(selectedValues)}
                        options={studentCanSeeOptions}
                        value={multiSelectValue()}
                        className={classes.studentCanSee}
                        placeholder="-Select-"
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                background: "#efefef"
                            }),
                        }}
                    />
                </div>

                <div className={classes.errMsg}><span>{errMsg ? errMsg : null}</span></div>
                {/* actions */}
                <div className={classes.googleFormPointFlex}>
                    <button onClick={backHandler} type="button" className={`${classes.googleFormBackButton} ${util.btn} ${util['btn--ghost']}`}>{'Back'}</button>
                    <button onClick={() => continueClickHandler()} type="button" className={`${classes.googleFormContinueButton} ${util.btn}`}>{'Continue'}</button>
                </div>
                <div>
                    <p onClick={stepSkipHandler} className={classes.googleFormSkip}>Skip this step</p>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ExportExtraInfoModal;
